export const DUMMY_LOGIN_CODE = [
  "satschel",
  "Satschel",
  "28c6b723-d43f-4904-b403-ca8eb8c5fbb8",
];
